<template>
    <vx-dropdown placement="right">
        <vx-button type="button" color="muted" outline class="w-[45px]" data-test="external-lists-dropdown">
            <font-awesome-icon widthAuto :icon="faEllipsis" />
        </vx-button>

        <template v-slot:items>
            <vx-dropdown-item
                :href="`/messaging/quick-blast?type=marketing&to=external-contact-lists&external_contact_list_ids%5B%5D=${externalList.id}`"
            >
                Send Quick Blast
                <font-awesome-icon widthAuto :icon="faRocket"></font-awesome-icon>
            </vx-dropdown-item>
            <vx-dropdown-item :href="`/contacts/external-contact-lists/${externalList.id}/access`">
                Manage Access
                <font-awesome-icon widthAuto :icon="faUserGroup"></font-awesome-icon>
            </vx-dropdown-item>
        </template>
    </vx-dropdown>
</template>

<script setup>
import { faRocket, faEllipsis, faUserGroup } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxButton, VxDropdown, VxDropdownItem } from '@voxie/frontend-components';

defineProps({
    externalList: {
        type: Object,
        required: true,
    },
});
</script>
